import React from "react";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 14,
    margin: "0 8px",
  },
  select: {
    padding: "2px 8px",
    borderRadius: 4,
    border: "1px solid #ddd",
    background: "#fff",
    fontSize: 14,
    color: "#333",
    outline: "none",
  },
};

const ResultPerPage = ({
  pageSize,
  setPageSize,
  options = [10, 25, 50, 100],
}) => {
  return (
    <div style={styles.container}>
      <span>Results per page:</span>
      <select
        style={styles.select}
        value={pageSize}
        onChange={(e) => setPageSize(Number(e.target.value))}
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ResultPerPage;
